import './main.css';
import {Elm} from './Main.elm';
import registerServiceWorker from './registerServiceWorker';

HTMLFontElement.prototype.replaceData =
    function replaceData(_0, _1, string) {
        this.parentNode.replaceChild(
            document.createTextNode(string),
            this
        );
    };

const storedState = localStorage.getItem('lcsession');
const startingState = storedState ? JSON.parse(storedState) : "";

const elmApp = Elm.Main.init({
    node: document.getElementById('root'),
    flags: startingState
});

elmApp.ports.setStorage.subscribe(function (state) {
    localStorage.setItem('lcsession', JSON.stringify(state));
});

elmApp.ports.scrollToElement.subscribe(function (elid) {
    console.log('Scroll tp ' + elid);
    const element = document.getElementById(elid);
    console.log(element);
    if (element){
        element.scrollIntoView({behavior: "smooth"})
    }
});

window.onoffline = (_event) => {
    console.log("Going offline.")
    elmApp.ports.onlineStatus.send("offline");
};

window.ononline = (_event) => {
    console.log("Going online.")
    elmApp.ports.onlineStatus.send("online");
};

registerServiceWorker();
